import { render, staticRenderFns } from "./cargoInput.vue?vue&type=template&id=3cf19adf&"
import script from "./cargoInput.vue?vue&type=script&lang=js&"
export * from "./cargoInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cf19adf')) {
      api.createRecord('3cf19adf', component.options)
    } else {
      api.reload('3cf19adf', component.options)
    }
    module.hot.accept("./cargoInput.vue?vue&type=template&id=3cf19adf&", function () {
      api.rerender('3cf19adf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/cargoInput.vue"
export default component.exports